import styled from "@emotion/styled/macro";
import {ISlsOrd} from "../../../kova/slsordClient";


const WaitingForSalesRepDiv = styled.div`

    width:100%;height:100%;
  display:flex;
  align-items: center;
  justify-content:center;
  p {
    text-align:center;
    font-weight:400;
    font-size:36px;
    line-height:43px;
  }
`

const WaitingForSalesRep: React.FC<{reservedSlsOrd: ISlsOrd}> = (props) => {

    const {reservedSlsOrd } = props;
    return <WaitingForSalesRepDiv><div>
        <img width={710} src={"/images/on2Logo.svg"} />
        <p>A Sales Associate will be with you shortly</p>
    <p>{reservedSlsOrd.marketingName}</p>
        <p>Block { reservedSlsOrd.blockNumber } Lot { reservedSlsOrd.lotNumber }  </p>
    </div></WaitingForSalesRepDiv>
}


export default WaitingForSalesRep;
